module.exports = __webpack_public_path__ + "static/media/Google Pixel 3 XL - Clearly White.406c5320.png";